// Demo data for showroom deployment (no backend needed)
// Rich, branded data for all VFootball features

const later = (hours) => {
  const d = new Date();
  d.setHours(d.getHours() + hours);
  return d.toISOString();
};
const earlier = (hours) => {
  const d = new Date();
  d.setHours(d.getHours() - hours);
  return d.toISOString();
};

// ============================================================
// TEAMS — used across matches, standings, lineups
// ============================================================
const TEAMS = {
  realMadrid: { id: 'rma', name: 'Real Madrid', short: 'RMA', logo: 'https://media.api-sports.io/football/teams/541.png', color: '#febe10' },
  bayern:     { id: 'bay', name: 'Bayern Munich', short: 'BAY', logo: 'https://media.api-sports.io/football/teams/157.png', color: '#dc052d' },
  manCity:    { id: 'mci', name: 'Manchester City', short: 'MCI', logo: 'https://media.api-sports.io/football/teams/50.png', color: '#6cabdd' },
  psg:        { id: 'psg', name: 'Paris Saint-Germain', short: 'PSG', logo: 'https://media.api-sports.io/football/teams/85.png', color: '#004170' },
  arsenal:    { id: 'ars', name: 'Arsenal', short: 'ARS', logo: 'https://media.api-sports.io/football/teams/42.png', color: '#ef0107' },
  chelsea:    { id: 'che', name: 'Chelsea', short: 'CHE', logo: 'https://media.api-sports.io/football/teams/49.png', color: '#034694' },
  liverpool:  { id: 'liv', name: 'Liverpool', short: 'LIV', logo: 'https://media.api-sports.io/football/teams/40.png', color: '#c8102e' },
  manUtd:     { id: 'mun', name: 'Manchester United', short: 'MUN', logo: 'https://media.api-sports.io/football/teams/33.png', color: '#da291c' },
  tottenham:  { id: 'tot', name: 'Tottenham', short: 'TOT', logo: 'https://media.api-sports.io/football/teams/47.png', color: '#132257' },
  villa:      { id: 'avl', name: 'Aston Villa', short: 'AVL', logo: 'https://media.api-sports.io/football/teams/66.png', color: '#670e36' },
  newcastle:  { id: 'new', name: 'Newcastle', short: 'NEW', logo: 'https://media.api-sports.io/football/teams/34.png', color: '#241f20' },
  brighton:   { id: 'bha', name: 'Brighton', short: 'BHA', logo: 'https://media.api-sports.io/football/teams/51.png', color: '#0057b8' },
  westHam:    { id: 'whu', name: 'West Ham', short: 'WHU', logo: 'https://media.api-sports.io/football/teams/48.png', color: '#7a263a' },
  fulham:     { id: 'ful', name: 'Fulham', short: 'FUL', logo: 'https://media.api-sports.io/football/teams/36.png', color: '#000000' },
  barcelona:  { id: 'bar', name: 'Barcelona', short: 'BAR', logo: 'https://media.api-sports.io/football/teams/529.png', color: '#a50044' },
  atletico:   { id: 'atm', name: 'Atletico Madrid', short: 'ATM', logo: 'https://media.api-sports.io/football/teams/530.png', color: '#cb3524' },
  sevilla:    { id: 'sev', name: 'Sevilla', short: 'SEV', logo: 'https://media.api-sports.io/football/teams/536.png', color: '#d50000' },
  betis:      { id: 'bet', name: 'Real Betis', short: 'BET', logo: 'https://media.api-sports.io/football/teams/543.png', color: '#0bb363' },
  milan:      { id: 'mil', name: 'AC Milan', short: 'MIL', logo: 'https://media.api-sports.io/football/teams/489.png', color: '#fb090b' },
  inter:      { id: 'int', name: 'Inter Milan', short: 'INT', logo: 'https://media.api-sports.io/football/teams/505.png', color: '#0068a8' },
  napoli:     { id: 'nap', name: 'Napoli', short: 'NAP', logo: 'https://media.api-sports.io/football/teams/492.png', color: '#0b73c0' },
  juventus:   { id: 'juv', name: 'Juventus', short: 'JUV', logo: 'https://media.api-sports.io/football/teams/496.png', color: '#000000' },
  dortmund:   { id: 'bvb', name: 'Borussia Dortmund', short: 'BVB', logo: 'https://media.api-sports.io/football/teams/165.png', color: '#fde100' },
  leipzig:    { id: 'rbl', name: 'RB Leipzig', short: 'RBL', logo: 'https://media.api-sports.io/football/teams/173.png', color: '#dd0741' },
  marseille:  { id: 'om',  name: 'Olympique Marseille', short: 'OM', logo: 'https://media.api-sports.io/football/teams/81.png', color: '#009ddc' },
};

// ============================================================
// LEAGUES
// ============================================================
const LEAGUES = {
  ucl:    { id: 'ucl', name: 'UEFA Champions League', logo: 'https://media.api-sports.io/football/leagues/2.png', flag: null, country: 'World' },
  epl:    { id: 'epl', name: 'Premier League', logo: 'https://media.api-sports.io/football/leagues/39.png', flag: 'https://media.api-sports.io/flags/gb.svg', country: 'England' },
  laliga: { id: 'laliga', name: 'La Liga', logo: 'https://media.api-sports.io/football/leagues/140.png', flag: 'https://media.api-sports.io/flags/es.svg', country: 'Spain' },
  serie:  { id: 'serie', name: 'Serie A', logo: 'https://media.api-sports.io/football/leagues/135.png', flag: 'https://media.api-sports.io/flags/it.svg', country: 'Italy' },
  bundes: { id: 'bundes', name: 'Bundesliga', logo: 'https://media.api-sports.io/football/leagues/78.png', flag: 'https://media.api-sports.io/flags/de.svg', country: 'Germany' },
  ligue1: { id: 'ligue1', name: 'Ligue 1', logo: 'https://media.api-sports.io/football/leagues/61.png', flag: 'https://media.api-sports.io/flags/fr.svg', country: 'France' },
};

// ============================================================
// CHANNELS — for streaming
// ============================================================
const makeChannels = (names) => names.map((name, i) => ({
  id: `ch-${name.toLowerCase().replace(/\s+/g, '-')}-${i}`,
  name,
  logo: null,
  providers: ['VFootball Network'],
  qualities: ['HD', 'FHD'],
  streamToken: `demo-${i}`,
  streamCount: 2
}));

// ============================================================
// LINEUPS — formation positions
// 4-3-3: GK, RB, CB, CB, LB, CM, CM, CM, RW, ST, LW
// ============================================================
const makeLineup = (teamShort, formation = '4-3-3') => {
  const namePool = [
    'Rodriguez', 'Silva', 'Martinez', 'Hernandez', 'Lopez', 'Gonzalez', 'Garcia',
    'Santos', 'Costa', 'Pereira', 'Ferreira', 'Almeida', 'Carvalho',
    'Müller', 'Schmidt', 'Becker', 'Werner', 'Schneider',
    'Dubois', 'Moreau', 'Laurent', 'Bernard', 'Petit',
    'Rossi', 'Conti', 'Ricci', 'Marino', 'Greco'
  ];
  const positions = formation === '4-3-3'
    ? [
        { x: 50, y: 92, role: 'GK', num: 1 },
        { x: 18, y: 72, role: 'LB', num: 3 },
        { x: 38, y: 76, role: 'CB', num: 4 },
        { x: 62, y: 76, role: 'CB', num: 5 },
        { x: 82, y: 72, role: 'RB', num: 2 },
        { x: 30, y: 50, role: 'CM', num: 8 },
        { x: 50, y: 55, role: 'CM', num: 6 },
        { x: 70, y: 50, role: 'CM', num: 10 },
        { x: 18, y: 25, role: 'LW', num: 11 },
        { x: 50, y: 18, role: 'ST', num: 9 },
        { x: 82, y: 25, role: 'RW', num: 7 },
      ]
    : [
        { x: 50, y: 92, role: 'GK', num: 1 },
        { x: 18, y: 72, role: 'LB', num: 3 },
        { x: 38, y: 76, role: 'CB', num: 4 },
        { x: 62, y: 76, role: 'CB', num: 5 },
        { x: 82, y: 72, role: 'RB', num: 2 },
        { x: 25, y: 50, role: 'CM', num: 6 },
        { x: 50, y: 55, role: 'CM', num: 8 },
        { x: 75, y: 50, role: 'CM', num: 10 },
        { x: 30, y: 22, role: 'CF', num: 11 },
        { x: 50, y: 18, role: 'CF', num: 9 },
        { x: 70, y: 22, role: 'CF', num: 7 },
      ];

  const used = new Set();
  return {
    formation,
    starters: positions.map(p => {
      let name;
      do { name = namePool[Math.floor(Math.random() * namePool.length)]; } while (used.has(name));
      used.add(name);
      return { ...p, name, rating: (6 + Math.random() * 3).toFixed(1) };
    }),
    substitutes: ['Kovac', 'Andrade', 'Bell', 'Romano', 'Tanaka', 'Diaz', 'Ozil'].map((name, i) => ({
      name, num: 12 + i, role: i === 0 ? 'GK' : 'SUB'
    }))
  };
};

// ============================================================
// MATCH STATS
// ============================================================
const makeStats = (homeStrong = true) => {
  const r = (a, b) => Math.floor(a + Math.random() * (b - a));
  const homeBias = homeStrong ? 1.2 : 0.8;
  return [
    { label: 'Possession', home: r(45, 65), away: 0, unit: '%', _autoAway: true },
    { label: 'Shots', home: Math.round(r(8, 18) * homeBias), away: r(6, 14) },
    { label: 'Shots on target', home: Math.round(r(3, 8) * homeBias), away: r(2, 6) },
    { label: 'Expected goals (xG)', home: (Math.random() * 2 + 0.5).toFixed(2), away: (Math.random() * 2 + 0.3).toFixed(2) },
    { label: 'Big chances', home: r(2, 5), away: r(1, 4) },
    { label: 'Corners', home: r(3, 9), away: r(2, 7) },
    { label: 'Fouls', home: r(6, 14), away: r(8, 16) },
    { label: 'Yellow cards', home: r(0, 3), away: r(1, 4) },
    { label: 'Red cards', home: 0, away: r(0, 2) > 1 ? 1 : 0 },
    { label: 'Passes', home: r(380, 580), away: r(320, 520) },
    { label: 'Pass accuracy', home: r(82, 92), away: 0, unit: '%', _autoAway: true },
  ].map(s => {
    if (s._autoAway) s.away = Math.max(0, 100 - s.home);
    return s;
  });
};

// ============================================================
// MATCH EVENTS
// ============================================================
const makeEvents = (homeScore, awayScore, homeShort, awayShort) => {
  const events = [];
  const minutesUsed = new Set();
  const randMinute = (lo, hi) => {
    let m;
    do { m = Math.floor(lo + Math.random() * (hi - lo)); } while (minutesUsed.has(m));
    minutesUsed.add(m);
    return m;
  };
  for (let i = 0; i < homeScore; i++) {
    events.push({ minute: randMinute(1, 88), team: 'home', teamShort: homeShort, type: 'goal', player: ['Rodriguez', 'Silva', 'Müller', 'Costa'][i % 4], assist: 'Hernandez' });
  }
  for (let i = 0; i < awayScore; i++) {
    events.push({ minute: randMinute(1, 88), team: 'away', teamShort: awayShort, type: 'goal', player: ['Lopez', 'Schmidt', 'Dubois'][i % 3], assist: 'Marino' });
  }
  // Add some cards
  events.push({ minute: randMinute(20, 80), team: 'home', teamShort: homeShort, type: 'yellow', player: 'Garcia' });
  events.push({ minute: randMinute(20, 80), team: 'away', teamShort: awayShort, type: 'yellow', player: 'Becker' });
  // Substitutions
  events.push({ minute: randMinute(60, 85), team: 'home', teamShort: homeShort, type: 'sub', playerOff: 'Conti', playerOn: 'Ozil' });
  return events.sort((a, b) => a.minute - b.minute);
};

// ============================================================
// HEAD-TO-HEAD (last 5)
// ============================================================
const makeH2H = (homeShort, awayShort) => {
  const competitions = ['Premier League', 'UCL', 'FA Cup', 'Premier League', 'Premier League'];
  const dates = ['2025-12-15', '2025-09-22', '2025-04-08', '2025-01-30', '2024-11-12'];
  return competitions.map((comp, i) => {
    const hs = Math.floor(Math.random() * 4);
    const as = Math.floor(Math.random() * 4);
    return {
      date: dates[i],
      competition: comp,
      home: homeShort,
      away: awayShort,
      homeScore: hs,
      awayScore: as,
      result: hs > as ? 'H' : as > hs ? 'A' : 'D'
    };
  });
};

// ============================================================
// MATCHES
// ============================================================
const buildMatch = (id, league, home, away, opts = {}) => {
  const {
    status = 'NS',
    minute = null,
    homeScore = null,
    awayScore = null,
    hoursOffset = 0,
    venue = 'Stadium',
    round = 'Matchday 1',
    channels = ['beIN Sports 1 HD', 'TNT Sports 1', 'ESPN HD']
  } = opts;

  const date = hoursOffset >= 0 ? later(hoursOffset) : earlier(-hoursOffset);
  const isLive = status === 'live';
  const isFinished = status === 'FT';

  return {
    id,
    date,
    time: date,
    status,
    minute,
    elapsed: minute,
    score: { home: homeScore, away: awayScore },
    teams: { home, away },
    league,
    venue,
    round,
    channels: channels.map(c => c),
    channelsWithLogos: makeChannels(channels),
    // Rich data for tabs
    lineups: {
      home: makeLineup(home.short),
      away: makeLineup(away.short, '4-2-3-1')
    },
    stats: (isLive || isFinished) ? makeStats(true) : null,
    events: (isLive || isFinished) ? makeEvents(homeScore || 0, awayScore || 0, home.short, away.short) : [],
    h2h: makeH2H(home.short, away.short)
  };
};

export const demoLeagueMatches = {
  success: true,
  leagues: [
    {
      ...LEAGUES.ucl,
      matches: [
        buildMatch('demo-1', LEAGUES.ucl, TEAMS.realMadrid, TEAMS.bayern, {
          status: 'live', minute: 67, homeScore: 2, awayScore: 1, hoursOffset: -1,
          venue: 'Santiago Bernabéu', round: 'Quarter-finals', channels: ['beIN Sports 1 HD', 'TNT Sports 1', 'CBS Sports Golazo']
        }),
        buildMatch('demo-2', LEAGUES.ucl, TEAMS.manCity, TEAMS.psg, {
          status: 'NS', hoursOffset: 2,
          venue: 'Etihad Stadium', round: 'Quarter-finals', channels: ['CBS Sports Golazo', 'BT Sport 2 HD']
        }),
      ]
    },
    {
      ...LEAGUES.epl,
      matches: [
        buildMatch('demo-3', LEAGUES.epl, TEAMS.arsenal, TEAMS.chelsea, {
          status: 'FT', homeScore: 3, awayScore: 2, hoursOffset: -3,
          venue: 'Emirates Stadium', round: 'Matchday 30', channels: ['Sky Sports Premier League', 'NBC Sports']
        }),
        buildMatch('demo-4', LEAGUES.epl, TEAMS.liverpool, TEAMS.manUtd, {
          status: 'live', minute: 23, homeScore: 0, awayScore: 1, hoursOffset: -0.5,
          venue: 'Anfield', round: 'Matchday 30', channels: ['Sky Sports Premier League', 'NBC Sports', 'Peacock']
        }),
        buildMatch('demo-5', LEAGUES.epl, TEAMS.tottenham, TEAMS.villa, {
          status: 'NS', hoursOffset: 4,
          venue: 'Tottenham Hotspur Stadium', round: 'Matchday 30', channels: ['Sky Sports Football']
        }),
        buildMatch('demo-12', LEAGUES.epl, TEAMS.newcastle, TEAMS.brighton, {
          status: 'NS', hoursOffset: 5,
          venue: "St James' Park", round: 'Matchday 30', channels: ['Sky Sports Premier League']
        }),
      ]
    },
    {
      ...LEAGUES.laliga,
      matches: [
        buildMatch('demo-6', LEAGUES.laliga, TEAMS.barcelona, TEAMS.atletico, {
          status: 'NS', hoursOffset: 1,
          venue: 'Camp Nou', round: 'Matchday 28', channels: ['DAZN LaLiga', 'ESPN+']
        }),
        buildMatch('demo-7', LEAGUES.laliga, TEAMS.sevilla, TEAMS.betis, {
          status: 'FT', homeScore: 1, awayScore: 1, hoursOffset: -2,
          venue: 'Ramón Sánchez-Pizjuán', round: 'Matchday 28', channels: ['DAZN LaLiga']
        }),
      ]
    },
    {
      ...LEAGUES.serie,
      matches: [
        buildMatch('demo-8', LEAGUES.serie, TEAMS.milan, TEAMS.inter, {
          status: 'NS', hoursOffset: 3,
          venue: 'San Siro', round: 'Matchday 29', channels: ['BT Sport 2 HD', 'Paramount+']
        }),
        buildMatch('demo-9', LEAGUES.serie, TEAMS.napoli, TEAMS.juventus, {
          status: 'live', minute: 82, homeScore: 4, awayScore: 0, hoursOffset: -1.5,
          venue: 'Diego Armando Maradona', round: 'Matchday 29', channels: ['ESPN HD', 'Paramount+']
        }),
      ]
    },
    {
      ...LEAGUES.bundes,
      matches: [
        buildMatch('demo-10', LEAGUES.bundes, TEAMS.dortmund, TEAMS.leipzig, {
          status: 'NS', hoursOffset: 5,
          venue: 'Signal Iduna Park', round: 'Matchday 27', channels: ['Sky Sport Bundesliga', 'ESPN+']
        })
      ]
    },
    {
      ...LEAGUES.ligue1,
      matches: [
        buildMatch('demo-11', LEAGUES.ligue1, TEAMS.psg, TEAMS.marseille, {
          status: 'NS', hoursOffset: 6,
          venue: 'Parc des Princes', round: 'Matchday 26', channels: ['Canal+ Sport HD', 'beIN Sports 2 HD']
        })
      ]
    }
  ]
};

// Build a map for quick match lookup by ID
const allDemoMatches = {};
demoLeagueMatches.leagues.forEach(league => {
  league.matches.forEach(match => {
    allDemoMatches[match.id] = match;
  });
});

export const getDemoMatchById = (id) => allDemoMatches[id] || null;

// ============================================================
// LIVE TICK SIMULATOR — mutates live matches every refresh
// ============================================================
let lastTick = Date.now();
export const tickLiveMatches = () => {
  const now = Date.now();
  const elapsedSec = (now - lastTick) / 1000;
  lastTick = now;

  Object.values(allDemoMatches).forEach(match => {
    if (match.status !== 'live') return;
    // Increment minute slowly
    if (Math.random() < 0.7) {
      match.minute = Math.min(90, (match.minute || 0) + 1);
      match.elapsed = match.minute;
    }
    // Random goal chance
    if (Math.random() < 0.08) {
      const scorer = Math.random() < 0.5 ? 'home' : 'away';
      match.score[scorer] = (match.score[scorer] || 0) + 1;
      const team = match.teams[scorer];
      match.events.push({
        minute: match.minute,
        team: scorer,
        teamShort: team.short,
        type: 'goal',
        player: ['Rodriguez', 'Silva', 'Müller', 'Costa', 'Lopez'][Math.floor(Math.random() * 5)],
        assist: 'Garcia'
      });
      match.events.sort((a, b) => a.minute - b.minute);
    }
    // End match if minute >= 90
    if (match.minute >= 90) {
      match.status = 'FT';
    }
  });
};

// ============================================================
// CHANNELS PAGE DATA
// ============================================================
export const demoChannels = {
  success: true,
  channels: [
    { name: 'beIN Sports 1 HD', provider: 'Premium A', streamUrl: '#demo' },
    { name: 'beIN Sports 2 HD', provider: 'Premium A', streamUrl: '#demo' },
    { name: 'beIN Sports 3 HD', provider: 'Premium A', streamUrl: '#demo' },
    { name: 'TNT Sports 1', provider: 'Premium B', streamUrl: '#demo' },
    { name: 'TNT Sports 2', provider: 'Premium B', streamUrl: '#demo' },
    { name: 'Sky Sports Premier League', provider: 'Premium A', streamUrl: '#demo' },
    { name: 'Sky Sports Football', provider: 'Premium A', streamUrl: '#demo' },
    { name: 'NBC Sports', provider: 'Premium B', streamUrl: '#demo' },
    { name: 'CBS Sports Golazo', provider: 'Premium C', streamUrl: '#demo' },
    { name: 'ESPN HD', provider: 'Premium C', streamUrl: '#demo' },
    { name: 'ESPN 2', provider: 'Premium C', streamUrl: '#demo' },
    { name: 'DAZN LaLiga', provider: 'Premium D', streamUrl: '#demo' },
    { name: 'DAZN 1', provider: 'Premium D', streamUrl: '#demo' },
    { name: 'BT Sport 1 HD', provider: 'Premium A', streamUrl: '#demo' },
    { name: 'BT Sport 2 HD', provider: 'Premium A', streamUrl: '#demo' },
    { name: 'Sky Sport Bundesliga', provider: 'Premium E', streamUrl: '#demo' },
    { name: 'Canal+ Sport HD', provider: 'Premium F', streamUrl: '#demo' },
    { name: 'Canal+ Foot', provider: 'Premium F', streamUrl: '#demo' },
    { name: 'SSC Sports 1', provider: 'Premium G', streamUrl: '#demo' },
    { name: 'SSC Sports 2', provider: 'Premium G', streamUrl: '#demo' },
    { name: 'SuperSport Football', provider: 'Premium H', streamUrl: '#demo' },
    { name: 'Fox Sports 1', provider: 'Premium B', streamUrl: '#demo' },
    { name: 'Movistar LaLiga', provider: 'Premium D', streamUrl: '#demo' },
    { name: 'Sport TV 1', provider: 'Premium I', streamUrl: '#demo' },
  ]
};

// ============================================================
// LEAGUE STANDINGS
// ============================================================
const buildStanding = (team, p, w, d, l, gf, ga, form) => ({
  team, p, w, d, l, gf, ga, gd: gf - ga, pts: w * 3 + d, form
});

export const demoStandings = {
  epl: {
    league: LEAGUES.epl,
    table: [
      buildStanding(TEAMS.arsenal,    30, 22, 5, 3, 68, 28, 'WWWDW'),
      buildStanding(TEAMS.manCity,    30, 21, 5, 4, 71, 30, 'WWLWW'),
      buildStanding(TEAMS.liverpool,  30, 20, 6, 4, 65, 32, 'WDWWL'),
      buildStanding(TEAMS.tottenham,  30, 17, 6, 7, 58, 41, 'LWDWW'),
      buildStanding(TEAMS.villa,      30, 16, 7, 7, 54, 42, 'WWDWL'),
      buildStanding(TEAMS.newcastle,  30, 15, 6, 9, 52, 44, 'DWLWW'),
      buildStanding(TEAMS.manUtd,     30, 14, 8, 8, 48, 40, 'LDWWL'),
      buildStanding(TEAMS.chelsea,    30, 13, 9, 8, 50, 45, 'WLDWW'),
      buildStanding(TEAMS.brighton,   30, 12, 8, 10, 46, 47, 'LWDLD'),
      buildStanding(TEAMS.westHam,    30, 11, 9, 10, 44, 49, 'DLWDW'),
      buildStanding(TEAMS.fulham,     30, 10, 8, 12, 41, 50, 'LDWLD'),
    ]
  },
  laliga: {
    league: LEAGUES.laliga,
    table: [
      buildStanding(TEAMS.realMadrid, 28, 22, 4, 2, 70, 22, 'WWWWW'),
      buildStanding(TEAMS.barcelona,  28, 19, 5, 4, 64, 32, 'WWDWL'),
      buildStanding(TEAMS.atletico,   28, 17, 6, 5, 55, 35, 'WDWWL'),
      buildStanding(TEAMS.sevilla,    28, 13, 8, 7, 45, 38, 'DWDWL'),
      buildStanding(TEAMS.betis,      28, 12, 9, 7, 42, 39, 'LWDWD'),
    ]
  },
  serie: {
    league: LEAGUES.serie,
    table: [
      buildStanding(TEAMS.inter,    29, 22, 4, 3, 68, 25, 'WWWWD'),
      buildStanding(TEAMS.milan,    29, 19, 6, 4, 62, 35, 'WWLWW'),
      buildStanding(TEAMS.juventus, 29, 17, 8, 4, 50, 28, 'DWDWW'),
      buildStanding(TEAMS.napoli,   29, 16, 7, 6, 55, 38, 'WWLWW'),
    ]
  },
  bundes: {
    league: LEAGUES.bundes,
    table: [
      buildStanding(TEAMS.bayern,   27, 21, 4, 2, 78, 30, 'WWWDW'),
      buildStanding(TEAMS.leipzig,  27, 17, 5, 5, 58, 35, 'WLWWD'),
      buildStanding(TEAMS.dortmund, 27, 16, 6, 5, 60, 38, 'WWDLW'),
    ]
  },
  ligue1: {
    league: LEAGUES.ligue1,
    table: [
      buildStanding(TEAMS.psg,       26, 20, 4, 2, 65, 22, 'WWWWW'),
      buildStanding(TEAMS.marseille, 26, 15, 7, 4, 48, 30, 'WDWWL'),
    ]
  }
};

// ============================================================
// TOP SCORERS
// ============================================================
export const demoTopScorers = {
  epl: [
    { rank: 1, name: 'Erling Haaland', team: TEAMS.manCity, goals: 24, assists: 5, matches: 28, photo: 'https://media.api-sports.io/football/players/1100.png' },
    { rank: 2, name: 'Mohamed Salah', team: TEAMS.liverpool, goals: 19, assists: 11, matches: 30, photo: 'https://media.api-sports.io/football/players/306.png' },
    { rank: 3, name: 'Bukayo Saka', team: TEAMS.arsenal, goals: 17, assists: 9, matches: 29, photo: 'https://media.api-sports.io/football/players/1460.png' },
    { rank: 4, name: 'Son Heung-min', team: TEAMS.tottenham, goals: 16, assists: 7, matches: 30, photo: 'https://media.api-sports.io/football/players/186.png' },
    { rank: 5, name: 'Cole Palmer', team: TEAMS.chelsea, goals: 15, assists: 8, matches: 28, photo: 'https://media.api-sports.io/football/players/3196.png' },
    { rank: 6, name: 'Ollie Watkins', team: TEAMS.villa, goals: 14, assists: 10, matches: 30, photo: 'https://media.api-sports.io/football/players/19220.png' },
    { rank: 7, name: 'Bruno Fernandes', team: TEAMS.manUtd, goals: 12, assists: 8, matches: 29, photo: 'https://media.api-sports.io/football/players/903.png' },
    { rank: 8, name: 'Alexander Isak', team: TEAMS.newcastle, goals: 11, assists: 4, matches: 27, photo: 'https://media.api-sports.io/football/players/19340.png' },
  ],
  laliga: [
    { rank: 1, name: 'Jude Bellingham', team: TEAMS.realMadrid, goals: 22, assists: 9, matches: 27, photo: 'https://media.api-sports.io/football/players/1485.png' },
    { rank: 2, name: 'Robert Lewandowski', team: TEAMS.barcelona, goals: 20, assists: 6, matches: 28, photo: 'https://media.api-sports.io/football/players/521.png' },
    { rank: 3, name: 'Vinícius Júnior', team: TEAMS.realMadrid, goals: 17, assists: 11, matches: 26, photo: 'https://media.api-sports.io/football/players/1486.png' },
    { rank: 4, name: 'Antoine Griezmann', team: TEAMS.atletico, goals: 15, assists: 8, matches: 28, photo: 'https://media.api-sports.io/football/players/1380.png' },
  ],
  serie: [
    { rank: 1, name: 'Lautaro Martínez', team: TEAMS.inter, goals: 24, assists: 5, matches: 29, photo: 'https://media.api-sports.io/football/players/2734.png' },
    { rank: 2, name: 'Olivier Giroud', team: TEAMS.milan, goals: 16, assists: 7, matches: 28, photo: 'https://media.api-sports.io/football/players/581.png' },
    { rank: 3, name: 'Victor Osimhen', team: TEAMS.napoli, goals: 15, assists: 4, matches: 25, photo: 'https://media.api-sports.io/football/players/278.png' },
  ],
  bundes: [
    { rank: 1, name: 'Harry Kane', team: TEAMS.bayern, goals: 28, assists: 8, matches: 26, photo: 'https://media.api-sports.io/football/players/184.png' },
    { rank: 2, name: 'Serhou Guirassy', team: TEAMS.dortmund, goals: 22, assists: 4, matches: 27, photo: 'https://media.api-sports.io/football/players/49344.png' },
  ],
  ligue1: [
    { rank: 1, name: 'Ousmane Dembélé', team: TEAMS.psg, goals: 18, assists: 12, matches: 25, photo: 'https://media.api-sports.io/football/players/270.png' },
  ]
};

// ============================================================
// EXPORT shared lookups
// ============================================================
export const TEAMS_BY_ID = TEAMS;
export const LEAGUES_BY_ID = LEAGUES;
